import { render, staticRenderFns } from "./MandatList.vue?vue&type=template&id=464f6192&scoped=true&%23pageContent=true&"
import script from "./MandatList.vue?vue&type=script&lang=js&"
export * from "./MandatList.vue?vue&type=script&lang=js&"
import style0 from "./MandatList.vue?vue&type=style&index=0&id=464f6192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464f6192",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('464f6192')) {
      api.createRecord('464f6192', component.options)
    } else {
      api.reload('464f6192', component.options)
    }
    module.hot.accept("./MandatList.vue?vue&type=template&id=464f6192&scoped=true&%23pageContent=true&", function () {
      api.rerender('464f6192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/MandatList.vue"
export default component.exports